import { render, staticRenderFns } from "./BidsList.vue?vue&type=template&id=992488da&scoped=true"
import script from "./BidsList.vue?vue&type=script&lang=js"
export * from "./BidsList.vue?vue&type=script&lang=js"
import style0 from "./BidsList.vue?vue&type=style&index=0&id=992488da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992488da",
  null
  
)

export default component.exports